import { dataService } from "@cabukaka/services";
import { Shop } from "@cabukaka/types"

export const adminService = {
    get baseService() {
        return dataService<Shop>("admin");
    },
    getManagedShop: async (token: string): Promise<Shop> => {
        try {
            return {} as Shop
        } catch (error) {
            throw error
        }
    },

    manageShop: async (shopId: string, token: string) => {
      try {
        
      } catch (error) {
        
      }
    }
}